(function () {
  var STORAGE_KEY = 'mg_la_unlocked';
  var REQUEST_KEY = 'mg_la_request_at';
  var REQUEST_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 días

  var gate = document.getElementById('mg-la-gate');
  if (!gate) return;

  var expectedHash = (gate.dataset.passwordHash || '').toLowerCase();
  var authorized = gate.dataset.authorized === '1';
  var form = gate.querySelector('.mg-la-gate__form');
  var input = gate.querySelector('.mg-la-gate__form .mg-la-gate__input');
  var error = gate.querySelector('.mg-la-gate__form .mg-la-gate__error');
  var tabs = gate.querySelectorAll('[data-la-tab]');
  var panes = gate.querySelectorAll('[data-la-pane]');
  var pendingBox = gate.querySelector('[data-la-pending]');
  var requestForm = gate.querySelector('#mg-la-request-form');
  var successServer = gate.querySelector('[data-la-request-success]');

  function sha256(text) {
    if (!window.crypto || !window.crypto.subtle) return Promise.resolve('');
    var enc = new TextEncoder().encode(text);
    return window.crypto.subtle.digest('SHA-256', enc).then(function (buf) {
      return Array.from(new Uint8Array(buf))
        .map(function (b) { return b.toString(16).padStart(2, '0'); })
        .join('');
    });
  }

  function unlock() {
    document.body.classList.remove('mg-la-locked');
    gate.hidden = true;
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
  }

  function lock() {
    document.body.classList.add('mg-la-locked');
    gate.hidden = false;
  }

  function isUnlocked() {
    if (document.documentElement.classList.contains('shopify-design-mode')) return true;
    if (authorized) return true;
    try { return sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }

  function markRequestSent() {
    try { localStorage.setItem(REQUEST_KEY, String(Date.now())); } catch (e) {}
  }

  function hasPendingRequest() {
    try {
      var raw = localStorage.getItem(REQUEST_KEY);
      if (!raw) return false;
      var t = parseInt(raw, 10);
      if (!t || isNaN(t)) return false;
      return Date.now() - t < REQUEST_TTL_MS;
    } catch (e) {
      return false;
    }
  }

  function showPane(name) {
    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-la-tab') === name;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panes.forEach(function (pane) {
      var on = pane.getAttribute('data-la-pane') === name;
      pane.classList.toggle('is-active', on);
      if (on) pane.removeAttribute('hidden');
      else pane.setAttribute('hidden', '');
    });

    if (name === 'request' && pendingBox && hasPendingRequest() && !successServer) {
      if (requestForm) requestForm.setAttribute('hidden', '');
      pendingBox.removeAttribute('hidden');
    } else if (name === 'request' && pendingBox && !successServer) {
      if (requestForm) requestForm.removeAttribute('hidden');
      pendingBox.setAttribute('hidden', '');
    }
  }

  // Si el form de contacto se envió bien, marcar pendiente
  if (successServer) {
    markRequestSent();
    showPane('request');
  }

  if (isUnlocked()) {
    unlock();
  } else {
    lock();
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      showPane(tab.getAttribute('data-la-tab'));
    });
  });

  gate.querySelectorAll('[data-la-goto]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      showPane(btn.getAttribute('data-la-goto'));
    });
  });

  if (requestForm && !successServer) {
    requestForm.addEventListener('submit', function () {
      // Marca local al enviar; el servidor confirma con form.posted_successfully?
      markRequestSent();
    });
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = (input && input.value) ? input.value.trim() : '';
      if (!expectedHash) {
        if (error) error.textContent = 'Clave no configurada en el tema.';
        return;
      }
      sha256(val).then(function (hash) {
        if (hash === expectedHash) {
          if (error) error.textContent = '';
          unlock();
          if (input) input.value = '';
        } else {
          if (error) error.textContent = 'Clave incorrecta. Solicita acceso o pídela a tu asesor Muscle Grenade.';
          if (input) { input.value = ''; input.focus(); }
        }
      });
    });
  }
})();
